export default __webpack_public_path__ + "static/media/icad.df537b7c.jpg";